import styled from 'styled-components';
import { screenSm } from 'constants/styles/breakpoints';
import { CONTENT_THUMBNAIL_GRADIENT } from 'constants/playlists';
import Icon from 'components/icons';

interface GroupItemImgProps extends React.HTMLAttributes<HTMLDivElement> {
  image?: string;
  disabled?: boolean;
}

export const Container = styled.div<{ image?: string; disabled?: boolean }>`
  display: none;

  ${({ disabled }) =>
    disabled &&
    `
  opacity: 0.6;
`}

  ${screenSm} {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: none;
    width: 133px;
    /* A stored URL can 404 once content is unpublished or migrated, and a failed
       image layer paints nothing. Keeping the gradient underneath it means the
       tile degrades to the brand fill instead of going blank. */
    background-image: ${({ image }) => (image ? `url("${image}"), ` : '')}${CONTENT_THUMBNAIL_GRADIENT};
    background-size: cover;
    border-radius: 10px 0px 0px 10px;
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  }
`;

// Every thumbnail carries the same open-in-new-tab affordance, whatever the
// content type — the tag beside it already says what the item is.
const GroupItemImg = ({ image, disabled, ...rest }: GroupItemImgProps): JSX.Element => (
  <Container image={image} disabled={disabled} {...rest}>
    <Icon color="#fff" icon="ExternalLink" style={{ opacity: disabled && '0.6' }} />
  </Container>
);

export default GroupItemImg;
